import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';

import '../../locales/i18n';

import ZendeskCTA from '../../common/zendesk-cta';
import MainHeader from '../../common/main-header';
import CardDeck from './components/card-deck';
import { Card, HelpCard } from './components/card';

import UserIllustration from 'images/illustration-users.svg';
import PostIllustration from 'images/illustration-post.svg';

class PartnersIndex extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Fragment>
        <MainHeader />
        <div className="my-4">
          <div className="container">
            <CardDeck>
              <Card
                action={{
                  name: i18n.t('partner_journey.create_account_button'),
                  href: '/partners/disconnect',
                }}
                title={i18n.t('partner_journey.create_account_title')}
                text={i18n.t('partner_journey.create_account_text')}
                image={PostIllustration}
              />

              <Card
                action={{
                  name: i18n.t('partner_journey.access_account_button'),
                  href: 'https://appstore.rdstation.com/publisher',
                }}
                title={i18n.t('partner_journey.access_account_title')}
                text={i18n.t('partner_journey.access_account_text')}
                image={UserIllustration}
              />
            </CardDeck>
          </div>
        </div>

        <ZendeskCTA />
      </Fragment>
    );
  }
};

const partners = () => {
  ReactDOM.render(<PartnersIndex />, document.getElementById('partners'));
};

document.addEventListener('DOMContentLoaded', partners);
